import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="bg-[#181715] text-[#FAF8F5]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 lg:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="[&_*]:!text-[#FAF8F5] [&_.text-muted-foreground]:!text-[#A39E93]">
            <Logo />
          </div>
          <p className="mt-6 text-[#A39E93] font-light leading-relaxed max-w-sm">
            Master flooring craftsmen. Hardwood, LVT, tiling, laminate, carpet
            and restoration — installed with architectural precision.
          </p>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-[#C87D32]">
            Est. with pride — every plank, every tile
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-[#A39E93] mb-6">
            Explore
          </h4>
          <ul className="space-y-3">
            {[
              ["Services", "/services"],
              ["Gallery", "/gallery"],
              ["About", "/about"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  className="group inline-flex items-center gap-1 text-[#FAF8F5]/90 hover:text-[#C87D32] transition-colors duration-300"
                >
                  {label}
                  <ArrowUpRight
                    size={14}
                    className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-[#A39E93] mb-6">
            Contact
          </h4>
          <ul className="space-y-4 text-[#FAF8F5]/90">
            <li className="flex items-center gap-3">
              <Phone size={16} className="text-[#C87D32]" />
              <a href="tel:+447521066187" className="hover:text-[#C87D32] transition-colors">
                +44 7521 066187
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="text-[#C87D32]" />
              <a href="mailto:cocflooringltd@gmail.com" className="hover:text-[#C87D32] transition-colors">
                cocflooringltd@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={16} className="text-[#C87D32]" />
              <span>London &amp; Surrounding Areas</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#2E2C28] flex flex-col sm:flex-row justify-between gap-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A39E93]">
          © {new Date().getFullYear()} COC Flooring Ltd. All rights reserved.
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#A39E93]">
          Crafted floors — enduring impressions
        </p>
      </div>
    </div>
  </footer>
);
